import {LOAD_POLICE_DATA, DELETE_A_POLICE, SAVE_A_POLICE, UPDATE_A_POLICE, CLEAR_A_POLICE_ERROR_MESSAGE} from './actions';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE} from "../towjob/actions";

const initialState = {
  policeArray:[],
    deletePoliceResp:{},
    errorCMsg:{},
    savePoliceResp:{},
    updatePoliceResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_POLICE_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_POLICE_DATA:
          return Object.assign({}, state, {
              policeArray: action.policeData
          });
          case DELETE_A_POLICE:
          return Object.assign({}, state, {
              deletePoliceResp: action.deletePoliceResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_POLICE:
          return Object.assign({}, state, {
              savePoliceResp: action.savePoliceResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_POLICE:
          return Object.assign({}, state, {
              updatePoliceResp: action.updatePoliceResponse,
              errorCMsg: action.errorMsg
          });

    default:
      return state;
  }
}
